import { render } from "./duk-list.vue?vue&type=template&id=4be51544&scoped=true"
import script from "./duk-list.vue?vue&type=script&lang=js"
export * from "./duk-list.vue?vue&type=script&lang=js"

import "./duk-list.vue?vue&type=style&index=0&id=4be51544&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be51544"]])

export default __exports__